var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2477_51864)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 35,
    fill: "#51CDA0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 31.0006V29.6673C52.3333 28.934 51.7333 28.334 51 28.334C50.2667 28.334 49.6667 28.934 49.6667 29.6673V31.0006H48.3333C47.6 31.0006 47 31.6006 47 32.334C47 33.0673 47.6 33.6673 48.3333 33.6673H49.6667V35.0006C49.6667 35.734 50.2667 36.334 51 36.334C51.7333 36.334 52.3333 35.734 52.3333 35.0006V33.6673H53.6667C54.4 33.6673 55 33.0673 55 32.334C55 31.6006 54.4 31.0006 53.6667 31.0006H52.3333ZM33.6667 35.0006C36.6133 35.0006 39 32.614 39 29.6673C39 26.7207 36.6133 24.334 33.6667 24.334C30.72 24.334 28.3333 26.7207 28.3333 29.6673C28.3333 32.614 30.72 35.0006 33.6667 35.0006ZM33.6667 36.334C30.1067 36.334 23 38.1206 23 41.6673V45.6673H44.3333V41.6673C44.3333 38.1206 37.2267 36.334 33.6667 36.334ZM39.68 24.4007C40.9067 25.814 41.6667 27.654 41.6667 29.6673C41.6667 31.6806 40.9067 33.5206 39.68 34.934C42.2933 34.6006 44.3333 32.3873 44.3333 29.6673C44.3333 26.9473 42.2933 24.734 39.68 24.4007ZM45.04 37.4406C46.2267 38.5473 47 39.934 47 41.6673V45.6673H49.6667V41.6673C49.6667 39.734 47.5467 38.3206 45.04 37.4406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2477_51864",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2477_51864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2477_51864",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroup);
export default __webpack_public_path__ + "static/media/createGroup.79746da42e8a8e7adc3fdf7f2c4132c6.svg";
export { ForwardRef as ReactComponent };